import {
  ACTIVE_LEADS_LANDING,
  DEFAULT_LANDING,
  NO_CAPABILITIES_LANDING,
  PERFORMANCE_ANALYSIS_LANDING,
} from "@/types/auth";
import { useIsInternalUser } from "@/hooks/useIsInternalUser";
import { useEntitlements } from "@/hooks/useEntitlements";

interface CapabilityLanding {
  /** True while contracts resolve — callers should hold rather than redirect. */
  loading: boolean;
  destination: string;
}

/**
 * Where the signed-in user belongs when they have no specific destination —
 * after login, or after being turned away from a route.
 *
 * Single source for this so a redirect can't land someone on a route another
 * guard will immediately reject: sending every external user to /active-leads
 * bounced revenue-only users straight into /no-access despite their holding
 * revenue.
 */
export function useCapabilityLanding(): CapabilityLanding {
  const isInternal = useIsInternalUser();
  const { loading, hasSales, hasRevenue } = useEntitlements();

  if (isInternal) return { loading: false, destination: DEFAULT_LANDING };
  if (loading) return { loading: true, destination: NO_CAPABILITIES_LANDING };
  // Sales first, so an external user holding both keeps today's landing page.
  if (hasSales) return { loading: false, destination: ACTIVE_LEADS_LANDING };
  if (hasRevenue)
    return { loading: false, destination: PERFORMANCE_ANALYSIS_LANDING };
  return { loading: false, destination: NO_CAPABILITIES_LANDING };
}
